import React, { useEffect } from 'react';
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';

import './Certificate.css';
import IconButton from '../IconButton/IconButton';
import { Icons } from '../../lib/icons';

gsap.registerPlugin(ScrollTrigger);

interface CertificateProps {
  id: string;
  name: string;
  certified: boolean;
  pdf: string;
}


const Certificate: React.FC<CertificateProps> = ({ id, name, certified, pdf }) => {
  // Certificate header text
  useEffect(() => {
    // Certificate separator
    gsap.fromTo(`.certificate#${id}`, { borderBottomColor: 'transparent' },
      {
        borderBottomColor: 'unset',
        scrollTrigger: {
          trigger: `.certificate#${id}`,
          toggleActions: 'play none none none'
        },
        duration: .2,
        delay: .2
      });
    gsap.fromTo(`.certificate-name#${id}`, { opacity: 0, x: -40 },
      {
        opacity: 1, x: 0,
        scrollTrigger: {
          trigger: `.certificate#${id}`,
          toggleActions: 'play none none none'
        },
        duration: .2,
      });
    // Certificate bottom text (Certified/Compliant)
    gsap.fromTo(`.certificate-certification#${id}`, { opacity: 0, x: -20 },
      {
        opacity: 1, x: 0,
        scrollTrigger: {
          trigger: `.certificate#${id}`,
          toggleActions: 'play none none none'
        },
        duration: .2,
        delay: .1
      });
    // View button
    if (pdf.length > 0) {
      gsap.fromTo(`.certificate-view#${id}`, { opacity: 0, x: 20 },
        {
          opacity: 1, x: 0,
          scrollTrigger: {
            trigger: `.certificate#${id}`,
            toggleActions: 'play none none none'
          },
          duration: .2,
          delay: .2
        });
    }
  }, [id, pdf]);

  return (
    <div className="certificate" id={id}>
      <div className="certificate-metadata" id={id}>
        <div className="certificate-name" id={id}>{name}</div>
        <div className="certificate-certification" id={id}>{certified ? 'Certified' : 'Compliant'}</div>
      </div>
      {pdf.length > 0 && (
        <IconButton
          name="View"
          icon={Icons.PDF}
          href={`/certs/${pdf}.pdf`}
          className="certificate-view"
          id={id}
        />
      )}
    </div>
  )
};

export default Certificate;